import { Inject, Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { InsectaServiceBase } from '../insecta.base.service';
import { IContainer } from '../insecta.models';
import { DictionaryCacheService } from '../dictionary-cache.service';
import { HttpClient } from '@angular/common/http';
import { SETTINGS, Settings } from '../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class ContainerAdminService extends InsectaServiceBase {
  constructor(
    private http: HttpClient,
    @Inject(SETTINGS) settings: Settings,
    private dictionaryCache: DictionaryCacheService
  ) {
    super(http, settings);
  }
  public addContainer(container: IContainer): Observable<string> {
    return this.post<string>(`/admin/containers`, `v1`, {
      name: container.name,
      containerTypeId: container.containerTypeId,
      username: container.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('container')));
  }

  public getContainers(): Observable<IContainer[]> {
    return this.get<IContainer[]>(`/admin/containers`, 'v1').pipe(
      map((results) =>
        [...results].sort((a: IContainer, b: IContainer) =>
          a.isActive == b.isActive ? (a.name > b.name ? 1 : -1) : a.isActive > b.isActive ? 1 : -1
        )
      )
    );
  }

  public getContainer(id: string): Observable<IContainer> {
    return this.get<IContainer>(`/admin/containers/${id}`, 'v1');
  }

  public updateContainer(container: IContainer): Observable<any> {
    return this.put<IContainer>(`/admin/containers/${container.id}`, `v1`, {
      id: container.id,
      name: container.name,
      containerTypeId: container.containerTypeId,
      isActive: container.isActive,
      username: container.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('container')));
  }
}
